import { useTranslator } from "@eo-locale/react";

import { Box, Text, Contribution } from "@/storybook-components";
import { buildImgixUrl, stripAllHtml } from "@/lib";
import { useAppSelector } from "@/redux/store/hooks";
import ActionList from "./action-list";

const PreviewCard = ({
  data,
  username,
  avatarURL,
  showCommentIcon = true
}): JSX.Element => {
  const { translate } = useTranslator();
  const { backgroundColours } = useAppSelector(
    (state) => state.toolCustomizations
  );
  const { brainstormer } = useAppSelector((state) => state.brainstormers);
  const { disableVoting } = brainstormer;

  return (
    <Box display="flex" flexDirection="column" gap={4} pointerEvents="none">
      <Text fontSize="sm" fontWeight="semibold">
        {translate("common.preview")}
      </Text>
      <Contribution
        cardDescription={data.description ? stripAllHtml(data.description) : ""}
        cardHeading={data.name}
        cardVariant="unstyled"
        commentsCount={0}
        contributionTime={translate("common.justNow")}
        imageAlt={null}
        imageSrc={data.mediaUrl || null}
        isThumbsUp={!disableVoting}
        showCommentIcon={showCommentIcon}
        isLoaded={true}
        shareText={translate("common.share")}
        showDescription
        showFooter
        showImage
        showDetailedText
        thumbsUpCount={0}
        tileBackgroundColor={
          data.backgroundColourId
            ? backgroundColours.find(
                ({ id }) => `${data.backgroundColourId}` === `${id}`
              )?.name
            : "gray.100"
        }
        username={username || translate("common.user")}
        userAvatarSrc={buildImgixUrl(avatarURL, 40, 40, "min")}
        showMoreOptions
        actionList={<ActionList menuList={[{}]} currentData={null} />}
      />
    </Box>
  );
};

export default PreviewCard;
